import {isNullOrUndef} from "chart.js/helpers";
// import I18n from 'i18n-js';
// I18n.locale = window.I18n.locale;
function checkBatterySearch(init = false) {
    init = init === true
    const newRecord = isNullOrUndef($('#warranty_id'))
    let battery_group       = $('#battery_group_id').val()
    let battery_brand       = $('#battery_brand_id').val()
    let battery_bci         = $('#battery_bci_id').val()
    let battery_condition   = $('#battery_condition_id').val()
    let batterySearch = { group_id: battery_group, brand_id: battery_brand,
        bci_id: battery_bci , condition_id: battery_condition }
    let params = { battery_search: batterySearch }
    if(newRecord === false) {
        params['id'] = $('#warranty_battery_id').val()
    }
    // let params = { group_id: battery_group, brand_id: battery_brand, bci_id: battery_bci , condition_id: battery_condition }
    $.get('/search/batteries', params)
        .done(function(data) {
            displayBatteryList(data,init)
            if(init) {
                let battery = data.batteries.find(b => String(b.model_id) === $('#battery_model_id').val())
                let container = document.getElementById('battery-search-container')
                let batteryId = $('#warranty_battery_id').val()
                !undefinedOrNull(battery) && !invalidString(batteryId) && selectBattery(battery, container, data, init)
            } else {
                $('#warranty_battery_id').val(null)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {

            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });

}
function initTable(description, interactive = true, columnExtra = false) {
    // Create the horizontal rules
    const hrTop = document.createElement('hr');
    const hrBottom = document.createElement('hr');
    hrTop.classList.add('table-divider');
    hrBottom.classList.add('table-divider');
    // Sección principal
    const mainSection = document.createElement('div');
    mainSection.id = 'dynamic-battery-section'; // ID para ocultar
    // Crear la sub-sección para la tabla y el encabezado
    const subSection = document.createElement('div');
    subSection.className = 'm-section__sub';

    // Crear el encabezado de la tabla (info de cantidad y texto)
    const headerRowDiv = document.createElement('div');
    headerRowDiv.className = 'row m-section__sub';
    headerRowDiv.style.display = 'flex';
    headerRowDiv.innerHTML = `
        <div class="col-12">
            <h4>${description}</h4>
        </div>
    `;
    subSection.appendChild(headerRowDiv);

    // Crear la tabla
    const table = document.createElement('table');
    table.className = 'table m-table m-table--head-separator-brand table-custom';
    if(interactive === true) {
        table.classList.add('interactive-table');
    }
    let colExtra = ''
    if(columnExtra && isNullOrUndef($('#warranty_id'))) {
        colExtra = '<th>Cancelar</th>'
    }
    const thead = document.createElement('thead');
    let cantidad = interactive ? '<th>Cantidad</th>' : ''
    thead.innerHTML = `
        <tr>
            `+cantidad+`
            <th>BCI</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Grupo</th>
            <th>Condición</th>
            <th>Precio lista</th>
            <th>Precio lista IVA</th>
            <th>Meses garantía</th>
            <th>Meses garantía flotilla</th>
            `+colExtra+`
        </tr>
    `;
    table.appendChild(thead);
    const tbody = document.createElement('tbody');
    return { table: table, mainSection: mainSection, subSection: subSection,
             headerRowDiv: headerRowDiv, thead: thead, tbody: tbody, hrTop: hrTop, hrBottom: hrBottom }
}
function createSelectedRow(battery, data, init = false) {
    init = init === true
    const td = document.createElement('td');
    const inputId = $('#warranty_id')
    if( isNullOrUndef(inputId) || isNullOrUndef(inputId.val()) || inputId.val() === '' ) {
        td.innerHTML = `<a class="red-cross">✕</a>`
        td.addEventListener('click', () => {
            // displayBatteryList(data)
            deselectBattery(data, false);
        });
    }
    const selectedRow = document.createElement('tr');
    selectedRow.className = 'selected-row';
    selectedRow.innerHTML = `
                <td>${battery.bci}</td>
                <td>${battery.brand}</td>
                <td>${battery.model}</td>
                <td>${battery.group}</td>
                <td>${battery.condition}</td>
                <td>${battery.list_price_currency}</td>
                <td>${battery.list_price_iva_currency}</td>
                <td>${battery.model_warranty}</td>
                <td>${battery.model_warranty_fleet}</td>
            `;
    selectedRow.appendChild(td)
    return selectedRow
}
function selectBattery(battery, container, data, init = false) {
    init = init === true
    let modelId = $('#warranty_battery_id').val()

    if (init === true && invalidString(modelId, false)) return;

    deselectBattery(battery,init,true)
    const table = initTable('Batería seleccionada:', false, true)
    const selectedRow = createSelectedRow(battery, data, init);
    if(init === true) {
        $('#battery_model_id').val(battery.model_id).trigger('change');
        $('#warranty_price').val($('#price').val())
    } else {
        $('#battery_model_id').val(battery.model_id).trigger('change');
        $('#warranty_price').val(battery.list_price_iva)
        $('#model_warranty_fleet').val(battery.model_warranty_fleet)
        $('#model_warranty').val(battery.model_warranty)
    }

    $('#battery_condition_id').val(battery.condition_id).trigger('change');
    $('#battery_group_id').val(battery.group_id).trigger('change');
    $('#battery_brand_id').val(battery.brand_id).trigger('change');
    $('#battery_bci_id').val(battery.bci_id).trigger('change');

    init === false && setWarranty()
    container.innerHTML = '';
    container.style.display = 'block'; // Asegurarse que esté visible si se ocultó antes
    table.tbody.appendChild(selectedRow);
    table.table.appendChild(table.tbody);
    table.subSection.appendChild(table.table);
    table.mainSection.appendChild(table.hrTop)
    table.mainSection.appendChild(table.subSection); // Añade la subsección (con tabla) a la sección principal
    table.mainSection.appendChild(table.hrBottom)
    container.appendChild(table.mainSection); // Añade la sección principal al contenedor
}


function checkVehicleSearch(init = false) {
    init = init === true
    // These hidden fields hold the values to re-select after a form error.
    const yearId = $('#vehicle_vehicles_years_id').val();
    const makeId = $('#make_id').val();
    const modelId = $('#model_id').val();
    const engineId = $('#engine_id').val();
    if (yearId) {
        // TODO: En setupWarrantiesForm despues de ejecutar checkBatterySearch
        //         Vuelve a crear la lista en checkVehicleSearch(true)
        //         pierde la seleccion de bateria
        getVehicleMakes(init)
            .then(function() {
                return getVehicleModels(init); // Return the promise to continue the chain
            })
            .then(function() {
                return getVehicleEngines(init, true); // Return the promise
            })
    }
}
function getVehicleMakes(init = false) {
    init = init === true
    $('#vehicle_vehicles_models_id').empty();
    $('#vehicle_vehicles_engines_id').empty();
    document.getElementById('bci-recomendado').innerHTML = ''
    let path = '/get/vehicle/makes/'+$('#vehicle_vehicles_years_id').val()
    return getVehicles('makes', 'vehicle_vehicles_years_id', 'vehicle_vehicles_makes_id', path, $('#make_id').val(), init)
}

function getVehicleModels(init = false) {
    init = init === true
    $('#vehicle_vehicles_engines_id').empty();
    document.getElementById('bci-recomendado').innerHTML = ''
    let path = '/get/vehicle/models/'+$('#vehicle_vehicles_years_id').val()+'/'+$('#vehicle_vehicles_makes_id').val()
    return getVehicles('models', 'vehicle_vehicles_makes_id', 'vehicle_vehicles_models_id', path, $('#model_id').val(), init)
}

function getVehicleEngines(init = false, manual = false) {
    init = init === true
    manual = manual === true
    let child = 'vehicle_vehicles_engines_id'
    let target_val   = $('#vehicle_vehicles_models_id').val()
    $('#'+child).empty().append(new Option('Seleccione una opción', ''));
    if (!target_val) {
        return $.Deferred().resolve().promise();
    }
    let path = '/get/vehicle/engines/'+$('#vehicle_vehicles_years_id').val()+'/'+$('#vehicle_vehicles_makes_id').val()+'/'+$('#vehicle_vehicles_models_id').val()
    let selectId = $('#engine_id').val()
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                data['engines'].forEach(item => {
                    $('#'+child).append(new Option(item.name, item.id));
                })
                $('#data_products').val(JSON.stringify(data['products']))
                if(selectId && init) {
                    $('#'+child).val(selectId).trigger('change');
                    setVehicleProduct(init)
                }
            } else {
                console.error('Something goes wrong while getting engines')
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });
}
function getVehicles(name, target, child, path, selectId = null, init = false) {
    init = init === true
    let target_val   = $('#'+target).val()
    $('#'+child).empty().append(new Option('Seleccione una opción', ''));
    if (!target_val) {
        // Return a resolved promise so the .then() chain doesn't break
        return $.Deferred().resolve().promise();
    }
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                data[name].forEach(item => {
                    $('#'+child).append(new Option(item.name, item.id));
                });
                if(selectId) {
                    $('#'+child).val(selectId)
                    init === true && $('#'+child).trigger('change');
                }
            } else {
                console.error('Something goes wrong while getting '+name)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });
}

function setVehicleProduct(init = false) {
    init = init === true
    init === false && deselectBattery(undefined, init, true)
    let engine_id = $('#vehicle_vehicles_engines_id').val()
    let str_products   = $('#data_products').val()
    let products = JSON.parse(str_products)
    const result = products.find(
        product => product.engine_id === Number(engine_id)
    );
    let bcis_array = result?.bcis_array
    let bcis = result?.bcis
    let bcis_ok = bcis_array && bcis_array[0]
    if(!isNullOrUndef(bcis)) {
        let target = document.getElementById('bci-recomendado')
        target.innerHTML = 'BCI: ' + result?.bcis
    }
    // TODO: rompe cosas?
    // if(bcis_ok && init === false) {
    if(bcis_ok) {
        $('#battery_group_id').val(null)
        $('#battery_brand_id').val(null)
        $('#battery_bci_id').val(null)
        $('#battery_condition_id').val(null)
        let foundValue = null;
        $('#battery_bci_id option').each(function() {
            if ($(this).text() === bcis_array[0]) {
                foundValue = $(this).val();
                return false;
            }
        });
        if (foundValue) {
            $('#battery_bci_id').val(foundValue).trigger('change.select2');
        } else {
            console.log("No option found with text: " + bcis_array[0]);
        }
        // init === true && checkBatterySearch(init)
        checkBatterySearch(init)
    }
}
function deselectBattery(data, init = false, manual = false) {
    init = init === true
    manual = manual === true
    let inputModel = $('#battery_model_id')
    let inputModelValue = undefinedOrNull(inputModel) ? '' : inputModel.val()
    if(manual === true) return
    if(init === true && !invalidString(inputModel.val())) return
    // $('#selected_battery_brand_id').val(null).trigger('change')
    $('#battery_id').val(null).trigger('change')
    $('#battery_model_id').val(null).trigger('change')
    // $('#battery_bci_id').val(null).trigger('change')
    // $('#battery_condition_id').val(null).trigger('change')
    // $('#battery_group_id').val(null).trigger('change')
    // $('#battery_brand_id').val(null).trigger('change')

    $('#warranty_battery_id').val(null)
    $('#warranty_warranty').val(null)
    $('#warranty_price').val(null)
    $('#model_warranty_fleet').val(null)
    $('#model_warranty').val(null)

    const container = document.getElementById('battery-search-container');
    if(!undefinedOrNull(container)) {
        container.innerHTML = '';
        container.style.display = 'block';
    }
    displayBatteryList(data, init)
}

function displayBatteryList(data, init = false) {
    init = init === true
    const container = document.getElementById('battery-search-container');
    if (!container || !data || !data.batteries) {
        if(!container) console.error('Missing container')
        if(!data) console.error('Missing data')
        if(!data.batteries) console.error('Missing data batteries')
        return;
    } else if (!data || !data.batteries) {
        if(!data) console.error('Missing data')
        if(!data.batteries) console.error('Missing data batteries')
        return;
    }
    container.innerHTML = '';
    container.style.display = 'block';
    const batteries = data.batteries;
    if (!init && (!batteries || batteries.length === 0)) {
        const noResultsDiv = document.createElement('div');
        noResultsDiv.className = 'm-section__content';
        noResultsDiv.innerHTML = '<hr class="table-divider"><p class="no-results text-centered">No se encontraron Baterías</p><hr class="table-divider">';
        container.appendChild(noResultsDiv);
        return;
    }
    const table = initTable('Seleccione una batería:')
    batteries.forEach(battery => {
        const tr = document.createElement('tr');
        tr.className = 'tr-custom';
        tr.innerHTML = `
                <td>${battery.cantidad}</td>
                <td>${battery.bci}</td>
                <td>${battery.brand}</td>
                <td>${battery.model}</td>
                <td>${battery.group}</td>
                <td>${battery.condition}</td>
                <td>${battery.list_price_currency}</td>
                <td>${battery.list_price_iva_currency}</td>
                <td>${battery.model_warranty}</td>
                <td>${battery.model_warranty_fleet}</td>
            `;
        tr.addEventListener('click', () => {
            selectBattery(battery, container, data, false);
        });
        table.tbody.appendChild(tr);
        if(init === true) {
            // let brand = $('#selected_battery_brand_id').val()

            let bciMatch = toStrEql(battery.bci_id, $('#battery_bci_id').val())
            let conditionMatch = toStrEql(battery.condition_id, $('#battery_condition_id').val())
            let brandMatch = toStrEql(battery.brand_id, $('#battery_brand_id').val())
            let batteryIdPresent = !invalidString($('#warranty_battery_id').val())

            if(bciMatch && conditionMatch && brandMatch && batteryIdPresent) {
                selectBattery(battery, container, data, init);
            }
        }

    });
    table.table.appendChild(table.tbody);
    table.subSection.appendChild(table.table);
    table.mainSection.appendChild(table.hrTop)
    table.mainSection.appendChild(table.subSection); // Añade la subsección (con tabla) a la sección principal
    table.mainSection.appendChild(table.hrBottom)
    container.appendChild(table.mainSection); // Añade la sección principal al contenedor
}

function setWarranty() {
    let checked = $('#warranty_fleet') && $('#warranty_fleet').prop('checked')
    if(checked) {
        $('#warranty_warranty').val($('#model_warranty_fleet').val())
    } else {
        $('#warranty_warranty').val($('#model_warranty').val())
    }
}

/**
 * Unbinds the 'select2:select' event from one or more Select2 elements.
 *
 * @param {...string} select_ids - A comma-separated list of element IDs (without the #).
 */
function clearSelect2(...select_ids) {
    if (select_ids.length === 0) {
        return;
    }
    // Build a single jQuery selector for all IDs.
    const selector = select_ids.map(id => '#' + id).join(', ');
    // Use the combined selector to turn off the event for all matched elements.
    $(selector).off('select2:select');
}
const select2Ids = ['battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id','vehicle_vehicles_years_id','vehicle_vehicles_makes_id','vehicle_vehicles_models_id','vehicle_vehicles_engines_id']
function setupWarrantiesForm() {
    const form = document.getElementById("warranties_form");
    if (form) {
        // console.log('warranties turbolinks loaded.')
        // Clear previous listeners
        // clearSelect2('battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id')
        // clearSelect2('vehicle_vehicles_years_id','vehicle_vehicles_makes_id','vehicle_vehicles_models_id','vehicle_vehicles_engines_id')
        clearSelect2(...select2Ids)
        // Init search select inputs
        checkBatterySearch(true)
        checkVehicleSearch(true)
        // Attach new listeners
        $(document)
            .on('select2:select', '#battery_group_id', checkBatterySearch)
            .on('select2:select', '#battery_brand_id', checkBatterySearch)
            .on('select2:select', '#battery_bci_id', checkBatterySearch)
            .on('select2:select', '#battery_condition_id', checkBatterySearch)
            .on('select2:select', '#vehicle_vehicles_years_id', getVehicleMakes)
            .on('select2:select', '#vehicle_vehicles_makes_id', getVehicleModels)
            .on('select2:select', '#vehicle_vehicles_models_id', getVehicleEngines)
            .on('select2:select', '#vehicle_vehicles_engines_id', setVehicleProduct)
            .on('change', '#warranty_phone_number', getCustomer)
            .on('change', '#warranty_fleet', setWarranty)
    }
}

function getCustomer()  {
    $('#phone_error_message').hide();
    let phone_number = $('#warranty_phone_number').val()
    if (!phone_number || phone_number.length < 10) {
        return $.Deferred().resolve().promise();
    }
    $('#warranty_first_name').val()
    $('#warranty_last_name').val()
    $('#warranty_email').val()
    let path = '/search/customer/' + $('#warranty_phone_number').val()
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                if (data.customer) {
                    $('#warranty_phone_number').val(phone_number)
                    $('#warranty_first_name').val(data.customer.first_name)
                    $('#warranty_last_name').val(data.customer.last_name)
                    $('#warranty_email').val(data.customer.email)
                } else {
                    $('#phone_error_message').show();
                }
            } else {
                console.error('Something goes wrong while getting '+phone_number)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });

}

function destroyWarrantiesForm() {
    const form = document.getElementById("warranties_form");
    if (form) {
        // console.log("Cleanup warranties_form...")
        document.removeEventListener("turbolinks:load", setupWarrantiesForm);
        document.removeEventListener('turbolinks:before-cache', destroyWarrantiesForm)

        $(document)
            .off('select2:select', '#battery_group_id', checkBatterySearch)
            .off('select2:select', '#battery_brand_id', checkBatterySearch)
            .off('select2:select', '#battery_bci_id', checkBatterySearch)
            .off('select2:select', '#battery_condition_id', checkBatterySearch)
            .off('select2:select', '#vehicle_vehicles_years_id', getVehicleMakes)
            .off('select2:select', '#vehicle_vehicles_makes_id', getVehicleModels)
            .off('select2:select', '#vehicle_vehicles_models_id', getVehicleEngines)
            .off('select2:select', '#vehicle_vehicles_engines_id', setVehicleProduct)
            .off('change', '#warranty_phone_number', getCustomer)

    }
}
document.addEventListener("turbolinks:load", setupWarrantiesForm);
// document.addEventListener('turbolinks:before-cache', destroyWarrantiesForm);
window.addEventListener('beforeunload', (event) => {
    destroyWarrantiesForm();
});

window.checkBatterySearch = checkBatterySearch;
window.displayBatteryList = displayBatteryList;
window.checkVehicleSearch = checkVehicleSearch;
window.getVehicleMakes = getVehicleMakes;
window.getVehicleModels = getVehicleModels;
window.getVehicleEngines = getVehicleEngines;
window.setVehicleProduct = setVehicleProduct;
window.getCustomer = getCustomer;
